import { mcpErrorMessage, type MCPApiError as ApiError } from "../errors";
import { canNotifyMCPMutation, useScopedMCPMutation } from "./useScopedMCPMutation";
import { mcpRequestOptions } from "./useMCPQueryScope";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import {
  agentToolsApi,
  type MCPOAuthInit,
} from "../../../services/agent-tools-service";


type Options = {
  onSuccess?: (init: MCPOAuthInit) => void;
  onError?: () => void;
};

export const useReconnectMCPConnection = (options: Options = {}) => {
  const { t, i18n } = useTranslation();
  return useScopedMCPMutation<MCPOAuthInit, string, undefined, ApiError>({
    mutationFn: (id, scope) => agentToolsApi.oauthLogin(id, mcpRequestOptions(scope)),
    onSuccess: (init, _id, scope) => {
      if (canNotifyMCPMutation(scope)) options.onSuccess?.(init);
    },
    onError: (error: ApiError, _id, _context, scope) => {
      if (!canNotifyMCPMutation(scope, error)) return;
      toast.error(mcpErrorMessage(error, t("mcpPage.mutation.reauthorizeFailed"), i18n.resolvedLanguage ?? i18n.language));
      options.onError?.();
    },
  });
};
